module.exports = __webpack_public_path__ + "img/identity-green-c.7692379d.svg";